const acciones = [
    { slug:'ver', label: "Ver" },
    { slug:'crear', label: "Crear" },
    { slug:'modificar', label: "Modificar" },
    { slug:'eliminar', label: "Eliminar" },
]

const logotipo = window.location.protocol + "//" + window.location.host + "/logo-mesina.png"
const logotipo_2 = window.location.protocol + "//" + window.location.host + "/images/logo-mesina.png"
const url_images = window.location.protocol + "//" + window.location.host + "/images"

const modos_sistema = {
    proveedor: {
      slug: "proveedor"
    },
    cliente: {
      slug: 'cliente'
    },
    courriers: {
      slug: 'courriers'
    }
  }
  
  const gps_integrados = [
    { slug: "mavigps", logo: `${url_images}/integraciones/gps/mavigps.png` },
    { slug: "gps-chile", logo: `${url_images}/integraciones/gps/gps-chile.png` },
    { slug: "autotrack", logo: `${url_images}/integraciones/gps/autotrack.png` },
  ]

  const mercado_pago_public_key = 'APP_USR-6248f20c-6a9a-4010-9da9-98c53a7efb95'

module.exports = {
    acciones,
    logotipo,
    logotipo_2,
    url_images,
    modos_sistema,
    mercado_pago_public_key,
    gps_integrados
}